import React from "react";
import Select, { Async } from "react-select";
import { Prompt } from "react-router-dom";
import moment from "moment";
import { RadioGroup, Radio } from "react-radio-group";
import Dialog from "../../../components/dialog";
import Overlay from "../../../components/overlay";
import {
  machineStatusesSelect,
  inspectionPrioritySelect,
  searchMachines
} from "../../../backend/machines";

export default function() {
  const {
    loading,
    dialogVisible,
    uploading,
    machine_hours,
    machine_id,
    status,
    require_swap,
    priority,
    inspection_pass,
    inspection_note,
    one_way_swap,
    created_at,
    savedForm,
    machine
  } = this.state;

  return (
    <div className="form">
      {loading && <Overlay />}
      <button onClick={this._navigate(`/machine-history/${machine_id}`)}>
        Previous Inspections
      </button>

      {!savedForm && [
        <label className={savedForm && "disabled"}>Machine Number</label>,
        <Select
          value={{
            label: machine.code,
            value: machine.id
          }}
        />
      ]}

      <label className={savedForm && "disabled"}>Test and Tag</label>
      <input
        disabled
        type="date"
        value={moment(created_at).format("YYYY-MM-DD")}
      />

      <label className={savedForm && "disabled"}>Machine Status</label>
      <Select
        isDisabled={savedForm}
        value={{ value: status, label: status }}
        onChange={this._change("status", true, true)}
        options={machineStatusesSelect}
      />

      <label className={savedForm && "disabled"}>Machine Hours</label>
      <input
        type="number"
        onChange={!savedForm && this._change("machine_hours")}
        value={machine_hours}
      />

      <label className={savedForm && "disabled"}>Inspection Passed</label>
      <RadioGroup
        className={`radio-group ${savedForm && "disabled"}`}
        name="inspection_pass"
        selectedValue={inspection_pass}
        onChange={!savedForm && this._change("inspection_pass", true)}
      >
        <div>
          <Radio value={true} /> <span>Yes</span>
        </div>
        <div>
          <Radio value={false} /> <span>No</span>
        </div>
      </RadioGroup>

      <label className={savedForm && "disabled"}>Machine Swap</label>
      <RadioGroup
        className={`radio-group ${savedForm && "disabled"}`}
        name="require_swap"
        selectedValue={require_swap}
        onChange={!savedForm && this._change("require_swap", true)}
      >
        <div>
          <Radio value={true} /> <span>Yes</span>
        </div>
        <div>
          <Radio value={false} /> <span>No</span>
        </div>
      </RadioGroup>

      {require_swap && [
        <label className={savedForm && "disabled"}>One Way Swap</label>,
        <RadioGroup
          className={`radio-group ${savedForm && "disabled"}`}
          name="one_way_swap"
          selectedValue={one_way_swap}
          onChange={!savedForm && this._change("one_way_swap", true)}
        >
          <div>
            <Radio value={true} /> <span>Yes</span>
          </div>
          <div>
            <Radio value={false} /> <span>No</span>
          </div>
        </RadioGroup>,
        <label className={savedForm && "disabled"}>New Machine Number</label>,
        <Async
          loadOptions={searchMachines}
          onChange={!savedForm && this._change("new_machine_id", true, true)}
        />
      ]}

      <label className={savedForm && "disabled"}>Priority</label>
      <Select
        isDisabled={savedForm}
        value={{ value: priority, label: priority }}
        onChange={this._change("priority", true, true)}
        options={inspectionPrioritySelect}
      />

      <label className={savedForm && "disabled"}>Note</label>
      <textarea
        value={inspection_note}
        onChange={!savedForm && this._change("inspection_note")}
      />

      {!savedForm && (
        <button disabled={!this._valid()} onClick={this._toggleSubmitDialog}>
          Submit Inspection
        </button>
      )}
      {dialogVisible && (
        <Dialog close={this._toggleSubmitDialog}>
          <div className="confirm-dialog">
            <p>Ready to submit?</p>
            <button
              onClick={() => {
                this._upload();
                this._toggleSubmitDialog();
              }}
            >
              Confirm
            </button>
          </div>
        </Dialog>
      )}
      {uploading && <Dialog loader />}
      {[
        !savedForm && (
          <Prompt message="You are cancelling. Your progress will be lost." />
        )
      ]}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/machines/machine-form/view.js